/** Generated interface artwork with PNG sources and hashes in art/interface/<family>. */
export const AUTHORED_INTERFACE_FAMILIES = {
  "enemies-v1": {
    "zmb.shambler": "shambler",
    "zmb.runner": "runner",
    "zmb.bloater": "bloater",
    "zmb.brute": "brute",
    "zmb.spitter": "spitter",
    "zmb.screamer": "screamer",
    "zmb.crawler": "crawler",
    "zmb.stalker": "stalker",
    "zmb.hulk": "hulk",
    "zmb.necromancer": "necromancer",
    "zmb.carrier": "carrier",
    "zmb.abomination": "abomination",
    "zmb.boss_hive_matriarch": "boss-hive-matriarch",
    "zmb.boss_titan_necrolith": "boss-titan-necrolith",
  },
  "equipment-v1": {
    "ui.equipment.weapon": "slot-weapon",
    "ui.equipment.armor": "slot-armor",
    "ui.equipment.core": "slot-core",
    "ui.equipment.sensor": "slot-sensor",
    "ui.equipment.drive": "slot-drive",
    "ui.module.hex_weapon": "hex-weapon",
    "ui.module.hex_armor": "hex-armor",
    "ui.module.hex_core": "hex-core",
    "ui.module.hex_sensor": "hex-sensor",
    "ui.module.hex_drive": "hex-drive",
    "ui.module.krg_weapon": "krg-weapon",
    "ui.module.krg_armor": "krg-armor",
    "ui.module.krg_core": "krg-core",
    "ui.module.krg_sensor": "krg-sensor",
    "ui.module.krg_drive": "krg-drive",
    "ui.module.vlk_weapon": "vlk-weapon",
    "ui.module.vlk_armor": "vlk-armor",
    "ui.module.vlk_core": "vlk-core",
    "ui.module.vlk_sensor": "vlk-sensor",
    "ui.module.vlk_drive": "vlk-drive",
    "ui.module.omc_weapon": "omc-weapon",
    "ui.module.omc_armor": "omc-armor",
    "ui.module.omc_core": "omc-core",
    "ui.module.omc_sensor": "omc-sensor",
    "ui.module.omc_drive": "omc-drive",
    "ui.module.rdl_weapon": "rdl-weapon",
    "ui.module.rdl_armor": "rdl-armor",
    "ui.module.rdl_core": "rdl-core",
    "ui.module.rdl_sensor": "rdl-sensor",
    "ui.module.rdl_drive": "rdl-drive",
  },
  "portraits-v1": {
    "unit.aegis_prime": "aegis-prime",
    "unit.overwatch_nyx": "overwatch-nyx",
    "unit.warden_kastor": "warden-kastor",
    "unit.sable_marrow": "sable-marrow",
    "unit.ironclad_boone": "ironclad-boone",
    "unit.halcyon_vex": "halcyon-vex",
    "unit.sgt_rook": "sgt-rook",
    "unit.cipher_odd": "cipher-odd",
    "unit.cadet_01": "cadet-01",
    "unit.bulwark_titan": "bulwark-titan",
    "unit.kagemori_ward": "kagemori-ward",
    "unit.rampart_7": "rampart-7",
    "unit.basalt_golem": "basalt-golem",
    "unit.shieldwall_mk2": "shieldwall-mk2",
    "unit.tessen_guard": "tessen-guard",
    "unit.barricade": "barricade",
    "unit.scrap_bastion": "scrap-bastion",
    "unit.pillbox": "pillbox",
    "unit.hellion_vanguard": "hellion-vanguard",
    "unit.solaris_lance": "solaris-lance",
    "unit.ryujin_blade": "ryujin-blade",
    "unit.photon_stalker": "photon-stalker",
    "unit.striker_beta": "striker-beta",
    "unit.argent_tripod": "argent-tripod",
    "unit.grunt_cannon": "grunt-cannon",
    "unit.fang": "fang",
    "unit.rustbucket": "rustbucket",
    "unit.widow_zero": "widow-zero",
    "unit.nightshade": "nightshade",
    "unit.ember_wraith": "ember-wraith",
    "unit.kitsune_9": "kitsune-9",
    "unit.spark_plug": "spark-plug",
    "unit.mirage": "mirage",
    "unit.firecracker": "firecracker",
    "unit.glitch": "glitch",
    "unit.nailgun": "nailgun",
    "unit.seraph_unit": "seraph-unit",
    "unit.halo_mother": "halo-mother",
    "unit.medic_prime": "medic-prime",
    "unit.aurora_node": "aurora-node",
    "unit.patch_bot": "patch-bot",
    "unit.relay_kite": "relay-kite",
    "unit.field_nurse": "field-nurse",
    "unit.battery_mule": "battery-mule",
    "unit.toolbox": "toolbox",
  },
  "frames-v1": {
    "ui.frame.steel": "steel",
    "ui.frame.bronze": "bronze",
    "ui.frame.silver": "silver",
    "ui.frame.gold": "gold",
    "ui.frame.neon": "neon",
    "ui.frame.void": "void",
    "ui.frame.mega": "mega",
    "ui.frame.gladiator": "gladiator",
    "ui.frame.nexus": "nexus",
    "ui.frame.collector": "collector",
    "ui.frame.alliance": "alliance",
    "ui.frame.duel_mvp": "duel-mvp",
  },
  "emotes-v1": {
    "emote.zombie": "zombie",
    "emote.skull": "skull",
    "emote.fire": "fire",
    "emote.gg": "gg",
    "emote.salute": "salute",
    "emote.laugh": "laugh",
    "emote.shield": "shield",
    "emote.bolt": "bolt",
    "emote.rocket": "rocket",
    "emote.gem": "gem",
    "emote.crown": "crown",
    "emote.eyes": "eyes",
    "emote.boom": "boom",
    "emote.target": "target",
    "emote.ghost": "ghost",
    "emote.robot": "robot",
    "emote.trophy": "trophy",
    "emote.alien": "alien",
    "emote.dragon": "dragon",
    "emote.nuke": "nuke",
    "emote.sprout": "sprout",
    "emote.wrench": "wrench",
    "emote.campfire": "campfire",
    "emote.heartbot": "heartbot",
    "emote.signal": "signal",
    "emote.starburst": "starburst",
  },
} as const;

export const AUTHORED_INTERFACE_ART: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(AUTHORED_INTERFACE_FAMILIES).flatMap(([family, entries]) =>
    Object.entries(entries).map(([id, slug]) => [id, `/assets/interface/${family}/${slug}.webp`])),
);
